import React, { Component } from 'react';
import {
  Row, Col, Checkbox, Form, Radio, Input, DatePicker, Select,
} from 'antd';
import moment from 'moment';
import { formPropType } from 'utils/propType';
import { FormControl, FormRules, FormUtils } from 'form-control';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import translate from 'app/translations';
import { PROFILE_STEP_TYPES } from 'app/constants';
import AgentProfilePropType from '../AgentProfilePropType';
import WizardNav from './WizardNav';

const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;


export class ProfessionalComponent extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  onSubmit(nextPage) {
    const { form } = this.props;
    form.validateFieldsAndScroll((errors, values) => {
      if (!errors) {
        const payload = this.mapPayload(values);
        this.props.onSaveProfessionalInfoRequest(nextPage, payload);
      }
    });
  }

  onfhaHudChange(changeEvt) {
    if (changeEvt.target.value !== 'Yes') {
      this.props.form.resetFields([
        'hudFhaCertified',
      ]);
    }
  }

  showFhaHudDetails() {
    let isHudFhaCertified = this.props.form.getFieldValue('hudFhaCertified');
    if (typeof isHudFhaCertified === 'undefined') {
      const { professionalInfo } = this.props.agentProfile;
      const certifiedState = professionalInfo.hudFhaCertified;
      isHudFhaCertified = FormUtils.booleanToYesNo(certifiedState);
    }
    return isHudFhaCertified;
  }

  mapPayload(fieldValues = {}) {
    const { credentials, regionCoverage } = this.props.agentProfile;

    const payload = {
      professionalInfo: {
        ...fieldValues,
        hudFhaCertified: FormUtils.yesNoToBoolean(fieldValues.hudFhaCertified),
        complexProperties: FormUtils.yesNoToBoolean(fieldValues.complexProperties),
        newConstruction: FormUtils.yesNoToBoolean(fieldValues.newConstruction),
        defaultAppraisals: FormUtils.yesNoToBoolean(fieldValues.defaultAppraisals),
        multiFamilyAppraisals: FormUtils.yesNoToBoolean(fieldValues.multiFamilyAppraisals),
        vaApproved: FormUtils.yesNoToBoolean(fieldValues.vaApproved),
        usdaExperience: FormUtils.yesNoToBoolean(fieldValues.usdaExperience),
        pendingLitigation: FormUtils.yesNoToBoolean(fieldValues.pendingLitigation),
        lenderExcluded: FormUtils.yesNoToBoolean(fieldValues.lenderExcluded),
        disciplinaryAction: FormUtils.yesNoToBoolean(fieldValues.disciplinaryAction),
        suspension: FormUtils.yesNoToBoolean(fieldValues.suspension),
        licenseInGoodStanding: FormUtils.yesNoToBoolean(fieldValues.licenseInGoodStanding),
        licensureRefused: FormUtils.yesNoToBoolean(fieldValues.licensureRefused),
      },
      coverage: {
        ...regionCoverage,
        monthlyOrders: fieldValues.monthlyOrders,
        yearsAppraising: fieldValues.yearsAppraising,
      },
      credentials: {
        initialLicenseDate: fieldValues.initialLicenseDate,
        documents: [...credentials.documents],
      },
    };

    return payload;
  }

  render() {
    const { professionalInfo, constants, isCallInprogress } = this.props.agentProfile;

    const {
      APPRAISAL_METHODOLOGIES,
      PROPERTY,
      CLIENT,
      NUMBER_OF_CLIENTS,
      YEARS_APPRAISING,
      MONTHLY_ORDERS,
      SOFTWARE,
      SUPPORTED_FILE,
    } = constants;

    const yesNoRadio = [
      { label: this.t('Generic.yes'), value: 'Yes' },
      { label: this.t('Generic.no'), value: 'No' },
    ];

    const { form } = this.props;
    return (
      <div className="professional">
        <Form layout="vertical">
          <div className="card-container responsive-border">
            <h2 className="orange-text">{this.t('Professional.background')}</h2>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="languages"
                  displayName={this.t('Professional.languages')}
                  initialValue={professionalInfo.languages}
                  rules={[FormRules.REQUIRED]}
                >
                  <Input
                    maxLength={100}
                    autoComplete="off"
                    placeholder={this.t('Professional.languages')}
                  />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label={this.t('Professional.initialLicenseDateLabel')}
                >
                  {form.getFieldDecorator('initialLicenseDate', {
                    rules: [{
                      type: 'object',
                      required: true,
                      message: this.t('FormControl.validate.required',
                        { fieldName: this.t('Professional.initialLicenseDateField') }),
                    }],
                    initialValue: professionalInfo.initialLicenseDate ? moment(professionalInfo.initialLicenseDate, 'YYYY-MM-DD') : undefined,
                  })(
                    <DatePicker
                      className="full-width"
                      format="YYYY-MM-DD"
                      disabledDate={FormUtils.futureDates}
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item label={this.t('Professional.clientMix')}>
                  {form.getFieldDecorator(
                    'clientMix',
                    {
                      rules: [{
                        required: true,
                        message: this.t('FormControl.validate.required',
                          { fieldName: this.t('Professional.clientMix') }),
                      }],
                      initialValue: professionalInfo.clientMix,
                    },
                  )(<CheckboxGroup options={CLIENT.map(kv => ({ label: kv.name, value: kv.value }))} />)}
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="numOfClients"
                  displayName={this.t('Professional.numOfClients')}
                  initialValue={professionalInfo.numOfClients}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={NUMBER_OF_CLIENTS.map(kv => ({ label: kv.name, value: kv.value }))} />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="yearsAppraising"
                  displayName={this.t('Professional.yearsAppraising')}
                  initialValue={professionalInfo.yearsAppraising}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={YEARS_APPRAISING.map(kv => ({ label: kv.name, value: kv.value }))} />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="monthlyOrders"
                  displayName={this.t('Professional.monthlyOrders')}
                  initialValue={professionalInfo.monthlyOrders}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={MONTHLY_ORDERS.map(kv => ({ label: kv.name, value: kv.value }))} />
                </FormControl>
              </Col>
            </Row>
          </div>


          <div className="card-container responsive-border">
            <h2 className="orange-text">{this.t('Professional.software')}</h2>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="softwareType"
                  rules={[FormRules.REQUIRED]}
                  displayName={this.t('Professional.softwareType')}
                  initialValue={professionalInfo.softwareType || undefined}
                  placeholder={this.t('Generic.select')}
                >
                  <Select
                    showSearch
                    autoComplete="off"
                    placeholder={this.t('Generic.select')}
                  >
                    {
                      SOFTWARE.map(s => (<Select.Option value={s.value} key={s.value}>{s.name}</Select.Option>))
                    }
                  </Select>
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col>
                <Form.Item label={this.t('Professional.supportedTypes')}>
                  {this.props.form.getFieldDecorator(
                    'supportedFileTypes',
                    {
                      initialValue: professionalInfo.supportedFileTypes,
                      rules: [
                        {
                          required: true,
                          message: this.t('Professional.supportedTypesRequired'),
                        },
                      ],
                    },
                  )(
                    <Checkbox.Group
                      name="supportedFileTypes"
                    >
                      <Row gutter={16}>
                        {
                        SUPPORTED_FILE.map(type => (
                          <Col md={8} sm={12} key={type}>
                            <Checkbox value={type.value} checked="checked" key={type.value}>{type.name}</Checkbox>
                          </Col>
                        ))
                      }
                      </Row>
                    </Checkbox.Group>,
                  )}
                </Form.Item>
              </Col>
            </Row>
          </div>



          <div className="card-container responsive-border">
            <h2 className="orange-text">{this.t('Professional.experience')}</h2>
            <Row gutter={16}>
              <Col xs={24}>
                <Form.Item label={this.t('Professional.appraisalMethodologies')}>
                  {form.getFieldDecorator(
                    'appraisalMethodologies',
                    {
                      rules: [{
                        required: true,
                        message: this.t('FormControl.validate.required',
                          { fieldName: this.t('Professional.appraisalMethodologies') }),
                      }],
                      initialValue: professionalInfo.appraisalMethodologies,
                    },
                  )(<CheckboxGroup options={APPRAISAL_METHODOLOGIES.map(kv => ({ label: kv.name, value: kv.value }))} />)}
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={12} md={6}>
                <FormControl
                  form={form}
                  fieldName="hudFhaCertified"
                  displayName={this.t('Professional.hudFhaCertified')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.hudFhaCertified)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup onChange={this.onfhaHudChange} options={yesNoRadio} />
                </FormControl>
              </Col>
              <Col xs={12} md={6}>
                {this.showFhaHudDetails() === 'Yes' && (
                  <div>
                    <FormControl
                      form={form}
                      fieldName="hudFhaNumber"
                      displayName={this.t('Professional.hudFhaNumber')}
                      initialValue={professionalInfo.hudFhaNumber}
                    >
                      <Input
                        maxLength={100}
                        autoComplete="off"
                        placeholder={this.t('Professional.hudFhaNumber')}
                      />
                    </FormControl>
                  </div>
                )}
              </Col>
              <Col xs={24} md={12}>
                <Form.Item label={this.t('Professional.typicalProperties')}>
                  {form.getFieldDecorator(
                    'typicalProperties',
                    {
                      rules: [{
                        required: true,
                        message: this.t('FormControl.validate.required',
                          { fieldName: this.t('Professional.typicalProperties') }),
                      }],
                      initialValue: professionalInfo.typicalProperties,
                    },
                  )(<CheckboxGroup options={PROPERTY.map(kv => ({ label: kv.name, value: kv.value }))} />)}
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="complexProperties"
                  displayName={this.t('Professional.complexProperties')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.complexProperties)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="newConstruction"
                  displayName={this.t('Professional.newConstruction')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.newConstruction)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="defaultAppraisals"
                  displayName={this.t('Professional.defaultAppraisals')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.defaultAppraisals)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="multiFamilyAppraisals"
                  displayName={this.t('Professional.multiFamilyAppraisals')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.multiFamilyAppraisals)}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="vaApproved"
                  displayName={this.t('Professional.vaApproved')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.vaApproved)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="usdaExperience"
                  displayName={this.t('Professional.usdaExperience')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.usdaExperience)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
            </Row>
          </div>
          <div className="card-container responsive-border">
            <h2 className="orange-text">{this.t('Professional.disciplinary')}</h2>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="pendingLitigation"
                  displayName={this.t('Professional.pendingLitigation')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.pendingLitigation)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="lenderExcluded"
                  displayName={this.t('Professional.lenderExcluded')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.lenderExcluded)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="disciplinaryAction"
                  displayName={this.t('Professional.disciplinaryAction')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.disciplinaryAction)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="suspension"
                  displayName={this.t('Professional.suspension')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.suspension)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="licenseInGoodStanding"
                  displayName={this.t('Professional.licenseInGoodStanding')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.licenseInGoodStanding)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>
              </Col>
              <Col xs={24} md={12}>
                <FormControl
                  form={form}
                  fieldName="licensureRefused"
                  displayName={this.t('Professional.licensureRefused')}
                  initialValue={FormUtils.booleanToYesNo(professionalInfo.licensureRefused)}
                  rules={[FormRules.REQUIRED]}
                >
                  <RadioGroup options={yesNoRadio} />
                </FormControl>

              </Col>
            </Row>
          </div>

          <WizardNav
            agentProfile={this.props.agentProfile}
            isCallInProgress={isCallInprogress}
            currentPage={PROFILE_STEP_TYPES.PROFESSIONAL}
            onNavigate={this.onSubmit}
          />
        </Form>
      </div>
    );
  }
}

ProfessionalComponent.propTypes = {
  form: PropTypes.shape(formPropType).isRequired,
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  onSaveProfessionalInfoRequest: PropTypes.func.isRequired,
};

export default Form.create()(ProfessionalComponent);
